// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { frontmatter as fm0, toc as t0 } from '/Users/lijixiang/Work/power-design/site/.dumi/pages/index.tsx?type=frontmatter';
import { frontmatter as fm1, toc as t1 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/department-user-selector.md?type=frontmatter';
import { demoIndex as dmi1 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/department-user-selector.md?type=demo-index';
import { frontmatter as fm2, toc as t2 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/ag-grid-form-list-table.md?type=frontmatter';
import { demoIndex as dmi2 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/ag-grid-form-list-table.md?type=demo-index';
import { frontmatter as fm3, toc as t3 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/approval-reminder.md?type=frontmatter';
import { demoIndex as dmi3 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/approval-reminder.md?type=demo-index';
import { frontmatter as fm4, toc as t4 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/department-selection.md?type=frontmatter';
import { demoIndex as dmi4 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/department-selection.md?type=demo-index';
import { frontmatter as fm5, toc as t5 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/approval-process.md?type=frontmatter';
import { demoIndex as dmi5 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/approval-process.md?type=demo-index';
import { frontmatter as fm6, toc as t6 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/preference-select.md?type=frontmatter';
import { demoIndex as dmi6 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/preference-select.md?type=demo-index';
import { frontmatter as fm7, toc as t7 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/shortcut-selector.md?type=frontmatter';
import { demoIndex as dmi7 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/shortcut-selector.md?type=demo-index';
import { frontmatter as fm8, toc as t8 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/form-list-table.md?type=frontmatter';
import { demoIndex as dmi8 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/form-list-table.md?type=demo-index';
import { frontmatter as fm9, toc as t9 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/pro-form-upload.md?type=frontmatter';
import { demoIndex as dmi9 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/pro-form-upload.md?type=demo-index';
import { frontmatter as fm10, toc as t10 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/template-select.md?type=frontmatter';
import { demoIndex as dmi10 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/template-select.md?type=demo-index';
import { frontmatter as fm11, toc as t11 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/user-info-card.md?type=frontmatter';
import { demoIndex as dmi11 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/user-info-card.md?type=demo-index';
import { frontmatter as fm12, toc as t12 } from '/Users/lijixiang/Work/power-design/site/docs/changelog/flow-components.md?type=frontmatter';
import { demoIndex as dmi12 } from '/Users/lijixiang/Work/power-design/site/docs/changelog/flow-components.md?type=demo-index';
import { frontmatter as fm13, toc as t13 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/service-tool.md?type=frontmatter';
import { demoIndex as dmi13 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/service-tool.md?type=demo-index';
import { frontmatter as fm14, toc as t14 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/data-log.md?type=frontmatter';
import { demoIndex as dmi14 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/data-log.md?type=demo-index';
import { frontmatter as fm15, toc as t15 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/actions.md?type=frontmatter';
import { demoIndex as dmi15 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/actions.md?type=demo-index';
import { frontmatter as fm16, toc as t16 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/comment.md?type=frontmatter';
import { demoIndex as dmi16 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/comment.md?type=demo-index';
import { frontmatter as fm17, toc as t17 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/faker-mode.md?type=frontmatter';
import { demoIndex as dmi17 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/faker-mode.md?type=demo-index';
import { frontmatter as fm18, toc as t18 } from '/Users/lijixiang/Work/power-design/site/docs/changelog/power-design.md?type=frontmatter';
import { demoIndex as dmi18 } from '/Users/lijixiang/Work/power-design/site/docs/changelog/power-design.md?type=demo-index';
import { frontmatter as fm19, toc as t19 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/ee-footer.md?type=frontmatter';
import { demoIndex as dmi19 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/ee-footer.md?type=demo-index';
import { frontmatter as fm20, toc as t20 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/user-info.md?type=frontmatter';
import { demoIndex as dmi20 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/user-info.md?type=demo-index';
import { frontmatter as fm21, toc as t21 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/index.md?type=frontmatter';
import { demoIndex as dmi21 } from '/Users/lijixiang/Work/power-design/site/docs/flow-components/index.md?type=demo-index';
import { frontmatter as fm22, toc as t22 } from '/Users/lijixiang/Work/power-design/site/docs/mobile/user-selection.md?type=frontmatter';
import { demoIndex as dmi22 } from '/Users/lijixiang/Work/power-design/site/docs/mobile/user-selection.md?type=demo-index';
import { frontmatter as fm23, toc as t23 } from '/Users/lijixiang/Work/power-design/site/docs/mobile/tag-container.md?type=frontmatter';
import { demoIndex as dmi23 } from '/Users/lijixiang/Work/power-design/site/docs/mobile/tag-container.md?type=demo-index';
import { frontmatter as fm24, toc as t24 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/index.md?type=frontmatter';
import { demoIndex as dmi24 } from '/Users/lijixiang/Work/power-design/site/docs/power-design/index.md?type=demo-index';
import { frontmatter as fm25, toc as t25 } from '/Users/lijixiang/Work/power-design/site/docs/mobile/avatar-tag.md?type=frontmatter';
import { demoIndex as dmi25 } from '/Users/lijixiang/Work/power-design/site/docs/mobile/avatar-tag.md?type=demo-index';
import { frontmatter as fm26, toc as t26 } from '/Users/lijixiang/Work/power-design/site/docs/changelog/mobile.md?type=frontmatter';
import { demoIndex as dmi26 } from '/Users/lijixiang/Work/power-design/site/docs/changelog/mobile.md?type=demo-index';
import { frontmatter as fm27, toc as t27 } from '/Users/lijixiang/Work/power-design/site/docs/contribute/index.md?type=frontmatter';
import { demoIndex as dmi27 } from '/Users/lijixiang/Work/power-design/site/docs/contribute/index.md?type=demo-index';
import { frontmatter as fm28, toc as t28 } from '/Users/lijixiang/Work/power-design/site/docs/mobile/index.md?type=frontmatter';
import { demoIndex as dmi28 } from '/Users/lijixiang/Work/power-design/site/docs/mobile/index.md?type=demo-index';

export const filesMeta = {
  'index': {
    frontmatter: fm0,
    toc: t0,
  },
  'docs/power-design/department-user-selector': {
    frontmatter: fm1,
    toc: t1,
    demoIndex: dmi1,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/department-user-selector.md?type=text'),
  },
  'docs/power-design/ag-grid-form-list-table': {
    frontmatter: fm2,
    toc: t2,
    demoIndex: dmi2,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/ag-grid-form-list-table.md?type=text'),
  },
  'docs/flow-components/approval-reminder': {
    frontmatter: fm3,
    toc: t3,
    demoIndex: dmi3,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/flow-components/approval-reminder.md?type=text'),
  },
  'docs/power-design/department-selection': {
    frontmatter: fm4,
    toc: t4,
    demoIndex: dmi4,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/department-selection.md?type=text'),
  },
  'docs/flow-components/approval-process': {
    frontmatter: fm5,
    toc: t5,
    demoIndex: dmi5,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/flow-components/approval-process.md?type=text'),
  },
  'docs/power-design/preference-select': {
    frontmatter: fm6,
    toc: t6,
    demoIndex: dmi6,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/preference-select.md?type=text'),
  },
  'docs/power-design/shortcut-selector': {
    frontmatter: fm7,
    toc: t7,
    demoIndex: dmi7,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/shortcut-selector.md?type=text'),
  },
  'docs/power-design/form-list-table': {
    frontmatter: fm8,
    toc: t8,
    demoIndex: dmi8,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/form-list-table.md?type=text'),
  },
  'docs/power-design/pro-form-upload': {
    frontmatter: fm9,
    toc: t9,
    demoIndex: dmi9,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/pro-form-upload.md?type=text'),
  },
  'docs/power-design/template-select': {
    frontmatter: fm10,
    toc: t10,
    demoIndex: dmi10,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/template-select.md?type=text'),
  },
  'docs/power-design/user-info-card': {
    frontmatter: fm11,
    toc: t11,
    demoIndex: dmi11,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/user-info-card.md?type=text'),
  },
  'docs/changelog/flow-components': {
    frontmatter: fm12,
    toc: t12,
    demoIndex: dmi12,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/changelog/flow-components.md?type=text'),
  },
  'docs/power-design/service-tool': {
    frontmatter: fm13,
    toc: t13,
    demoIndex: dmi13,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/service-tool.md?type=text'),
  },
  'docs/flow-components/data-log': {
    frontmatter: fm14,
    toc: t14,
    demoIndex: dmi14,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/flow-components/data-log.md?type=text'),
  },
  'docs/flow-components/actions': {
    frontmatter: fm15,
    toc: t15,
    demoIndex: dmi15,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/flow-components/actions.md?type=text'),
  },
  'docs/flow-components/comment': {
    frontmatter: fm16,
    toc: t16,
    demoIndex: dmi16,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/flow-components/comment.md?type=text'),
  },
  'docs/power-design/faker-mode': {
    frontmatter: fm17,
    toc: t17,
    demoIndex: dmi17,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/faker-mode.md?type=text'),
  },
  'docs/changelog/power-design': {
    frontmatter: fm18,
    toc: t18,
    demoIndex: dmi18,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/changelog/power-design.md?type=text'),
  },
  'docs/power-design/ee-footer': {
    frontmatter: fm19,
    toc: t19,
    demoIndex: dmi19,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/ee-footer.md?type=text'),
  },
  'docs/power-design/user-info': {
    frontmatter: fm20,
    toc: t20,
    demoIndex: dmi20,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/user-info.md?type=text'),
  },
  'docs/flow-components/index': {
    frontmatter: fm21,
    toc: t21,
    demoIndex: dmi21,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/flow-components/index.md?type=text'),
  },
  'docs/mobile/user-selection': {
    frontmatter: fm22,
    toc: t22,
    demoIndex: dmi22,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/mobile/user-selection.md?type=text'),
  },
  'docs/mobile/tag-container': {
    frontmatter: fm23,
    toc: t23,
    demoIndex: dmi23,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/mobile/tag-container.md?type=text'),
  },
  'docs/power-design/index': {
    frontmatter: fm24,
    toc: t24,
    demoIndex: dmi24,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/index.md?type=text'),
  },
  'docs/mobile/avatar-tag': {
    frontmatter: fm25,
    toc: t25,
    demoIndex: dmi25,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/mobile/avatar-tag.md?type=text'),
  },
  'docs/changelog/mobile': {
    frontmatter: fm26,
    toc: t26,
    demoIndex: dmi26,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/changelog/mobile.md?type=text'),
  },
  'docs/contribute/index': {
    frontmatter: fm27,
    toc: t27,
    demoIndex: dmi27,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/contribute/index.md?type=text'),
  },
  'docs/mobile/index': {
    frontmatter: fm28,
    toc: t28,
    demoIndex: dmi28,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/mobile/index.md?type=text'),
  },
}

export { tabs as tabsMeta } from './tabs';
